// Recovered compiled webpack factory 49636. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  r.d(t, { O: () => n });
  let n = globalThis;
}
